export const state = () => ({
    fullyQualifiedURL: null,
    showCookiesBanner: false,
    showServerError: false,
    show404Error: false,
});

export const actions = {
    async showServerError(context) {
        await context.commit('showServerError', true);
    },

    async show404Error(context) {
        await context.commit('show404Error', true);
    },
};

export const mutations = {
    updateFullyQualifiedURL(state, url) {
        state.fullyQualifiedURL = url;
    },

    setShowCookiesBanner(state, showBanner) {
        state.showCookiesBanner = showBanner;
    },

    showServerError(state, status) {
        state.showServerError = status;
    },

    show404Error(state, status) {
        state.show404Error = status;
    },
};

export const getters = {
    getFullyQualifiedURL(state) {
        return state.fullyQualifiedURL;
    },

    getShowCookiesBanner(state) {
        return state.showCookiesBanner;
    },

    getShow404Error(state) {
        return state.show404Error;
    },
};
